import baseApi from "./baseApi"
import UtilService from '../services/utilService';

export default  {
    async getContractorOrganisations(){
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/preceda/getcontractororganisations");
        return result.data;
    },
    async getTeams(){
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/preceda/getteams");
        return result.data;
    },
    async downloadContractorExport(contractorOrganisationID, startDate, endDate) {
        let request = await baseApi.createHttpRequest("blob");
        let result = await request.get("/preceda/contractorexport?" + [
            "ContractorOrganisationID=" + contractorOrganisationID,
            "StartDate=" + UtilService.formatDateYMD(startDate),
            "EndDate=" + UtilService.formatDateYMD(endDate)
        ].join("&"));

        let url = window.URL.createObjectURL(new Blob([result.data]));
        let link = document.createElement("a");
        link.href = url;
        let contentDisposition = result.headers["content-disposition"];
        let fileName = 'unknown';
        if(contentDisposition){
            let fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if(fileNameMatch.length === 2){
                fileName = fileNameMatch[1];
            }
        }
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
    async getCropWorkPreview(contractorOrganisationID, teamName, startDate, endDate){
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/preceda/getcropworkpreview?" + [
            "ContractorOrganisationID=" + (contractorOrganisationID != null ? contractorOrganisationID : ""),
            "TeamName=" + (teamName != null ? teamName : ""),
            "StartDate=" + UtilService.formatDateYMD(startDate),
            "EndDate=" + UtilService.formatDateYMD(endDate)
        ].join("&"));
        return result.data;
    },
    async downloadCropWorkExport(contractorOrganisationID, teamName, startDate, endDate) {
        let request = await baseApi.createHttpRequest("blob");
        let result = await request.get("/preceda/cropworkexport?" + [
            "ContractorOrganisationID=" + (contractorOrganisationID != null ? contractorOrganisationID : ""),
            "TeamName=" + (teamName != null ? teamName : ""),
            "StartDate=" + UtilService.formatDateYMD(startDate),
            "EndDate=" + UtilService.formatDateYMD(endDate)
        ].join("&"));

        let url = window.URL.createObjectURL(new Blob([result.data]));
        let link = document.createElement("a");
        link.href = url;
        let contentDisposition = result.headers["content-disposition"];
        let fileName = 'unknown';
        if(contentDisposition){
            let fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if(fileNameMatch.length === 2){
                fileName = fileNameMatch[1];
            }
        }
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
}